import React, {Component} from 'react';
import { InputGroup, InputGroupAddon, InputGroupButton,  Fade, Input, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, Form, FormGroup,  FormFeedback } from 'reactstrap';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Icon from '@material-ui/core/Icon';
import GroupIcon from '@material-ui/icons/Videocam';
import NavigationIcon from '@material-ui/icons/Navigation';
import { Badge } from 'material-ui';
import { Player, ControlBar } from 'video-react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import ModalImage from 'react-modal-image'



const styles = theme => ({
    card: {
      display: 'flex',
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
    },
    content: {
      flex: '1 0 auto',
    },
    cover: {
      width: 200,
    },
    controls: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
    },
    playIcon: {
      height: 38,
      width: 38,
    },
  });



class VisualPictureComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
        photoIndex: 0,
        
        images: []
      };

  

}



	
  sendData(e){

	 this.toggle();
  }
  

  mediaControlCard(props, imageparam) {
    const { classes, theme } = props;
    //const { player } = this.refs.player.play()
    return (
      
      <Card style={{height: 200}} className={classes.card}>
        { /*
        <div className={classes.details}>
          <CardContent className={classes.content}>
            <Typography component="h5" variant="h5">
              {imageparam.title}
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              {imageparam.subtitle}
            </Typography>
          </CardContent>

        </div>
        */}

        <ModalImage
  small={ imageparam.link }
  large={imageparam.link}
  alt={imageparam.title}
/>
       

      </Card>
    );
  }

  render() {
    const { photoIndex, isOpen, images} = this.state;	  	  
    const { classes } = this.props;
	// prop clips holds an array of objects, where the object is a clip containing all clip information like id, etc. 
    return (
      <div>
{
  console.log('object in visualpicturecomp is: ', this.props.images)
}
       {
           
           this.props.images.length > 0 ? this.props.images.map( image => (                              
                
               this.mediaControlCard(this.props, image)
           )
           
        
           )
           
           : null
           
       }

      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(VisualPictureComponent);




// WEBPACK FOOTER //
// ./src/modules/movie-browser/VisualPictureComponent.js